import React, {useEffect, useState} from "react";
import {
    Card,
    Page,
    Layout
} from "@shopify/polaris";
import Http from "../Lib/Http";
import {Cell, ChartDataItem} from "../types";
import {useParams} from "react-router-dom";
import {useGoTo} from "@admin/Lib/useGoTo";
import Menu from "@admin/Lib/Menu";

interface StyleSettings {
    table_body_editable?: boolean;
    body_font?: string;
    body_font_size?: number;
    body_border_color?: string;
    body_border_width?: number;
    body_text_color?: string;
    body_background_color?: string;
    table_header_editable?: boolean;
    header_font?: string;
    header_font_size?: number;
    header_border_color?: string;
    header_border_width?: number;
    header_text_color?: string;
    header_background_color?: string;
    trigger_editable?: boolean;
    trigger_font?: string;
    trigger_font_size?: number;
    trigger_color?: string;
    underline_trigger?: boolean;
    table_collapse?: boolean;
    table_alignment?: string;
}
function Help() {
    const [chart, setChart] = useState< ChartDataItem[][] | null>(null);
    const [loading, setLoading] = useState(false);
    const routeParams = useParams();
    const chartId = routeParams.chartID;
    const goTo = useGoTo();

    useEffect(() => {
        getChart();
        getShops();
    }, []);

    const html = {
        escape: (unsafe: string): string => {
            return unsafe
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");
        },

        unescape: (safe: string): string => {
            const div = document.createElement("div");
            div.innerHTML = safe;
            return div.innerText || div.textContent || ""; // Adjusted for potential null value
        },
    };

    const fromDbCell = (cell: string): Cell => {
        const textRegExp = new RegExp(/^<span class="esc-size-guide--cell-type--text">(.*)<\/span>$/);
        if (textRegExp.test(cell)) return { type: "text", value: html.unescape(cell.match(textRegExp)![1]) }; // Non-null assertion for match result

        const dressRegExp = new RegExp(/^<span class="esc-size-guide--cell-type--dress">(.*)<\/span>$/);
        if (dressRegExp.test(cell)) return { type: "dress", value: html.unescape(cell.match(dressRegExp)![1]) }; // Non-null assertion for match result

        const imgRegExp = new RegExp(/^<img class="esc-size-guide--cell-type--img" src="(.*)"\/>$/);
        if (imgRegExp.test(cell)) return { type: "img", value: cell.match(imgRegExp)![1] }; // Non-null assertion for match result

        return { type: "html", value: cell };
    };

    const getChart = () => {

        Http.get(`/app/api/v1/charts/${chartId}/preview`)
            .then((response) => {
                let tmpChart = response.data.chart.data;
                let data = (tmpChart || []).map((row: any[]) => row.map((cell) => fromDbCell(cell)));
                setChart(data);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };
    const isHeader = (i : number, j : number) => {
            return false;
    };


    const getShops = () => {

        Http.get(`/app/api/v1/shop.json?charts=1`)
            .then((response) => {
                let shop = response.data.shop
                Menu.loadMenu(shop);

                convertStylesToCSS(JSON.parse(shop.styles));
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };


    const convertStylesToCSS = (styleSettings: StyleSettings) => {
        let css = '';

        if (styleSettings.table_body_editable) {
            css += ".esc-size-guide--cell:not(.esc-size-guide--row1){";

            if (styleSettings.body_font) {
                css += `font-family:${styleSettings.body_font};`;
            }

            css += `font-size:${styleSettings.body_font_size}px;`;
            css += `border-color:${styleSettings.body_border_color};`;
            css += `border-width:${styleSettings.body_border_width}px;`;
            css += `color:${styleSettings.body_text_color};`;
            css += `background-color:${styleSettings.body_background_color};`;
            css += "}";
        }

        if (styleSettings.table_header_editable) {
            css += ".esc-size-guide--row1{";

            if (styleSettings.header_font) {
                css += `font-family:${styleSettings.header_font};`;
            }

            css += `font-size:${styleSettings.header_font_size}px !important;`;
            css += `border-color:${styleSettings.header_border_color} !important;`;
            css += `border-width:${styleSettings.header_border_width}px !important;`;
            css += `color:${styleSettings.header_text_color} !important;`;
            css += `background-color:${styleSettings.header_background_color} !important;`;
            css += "}";
        }

        if (styleSettings.trigger_editable) {
            css += '[data-app="eastsideco_sizeGuides"] a{';

            if (styleSettings.trigger_font) {
                css += `font-family:${styleSettings.trigger_font};`;
            }

            css += `font-size:${styleSettings.trigger_font_size}px;`;
            css += `color:${styleSettings.trigger_color};`;

            if (styleSettings.underline_trigger) {
                css += `text-decoration:${styleSettings.underline_trigger ? 'underline' : 'none'};`;
            }

            css += "}";
        }

        if (styleSettings.table_collapse) {
            css += '.esc-size-guide--table{ border-collapse: collapse;}';
        }

        if (styleSettings.table_alignment) {
            css += `.esc-size-guide--table-wrap{ text-align: ${styleSettings.table_alignment};}`;
        }

        const styleElement = document.createElement('style');
        styleElement.type = 'text/css';
        styleElement.appendChild(document.createTextNode(css));

        window.document.head.appendChild(styleElement);
    }



    return (
        <Page backAction={{
            content: 'Home', onAction() {
                goTo('')
            }
        }}
              title="Chart Preview ">
            <Layout>
                <Layout.Section>
                    <Card roundedAbove="sm">

                        {chart &&
                            <div style={{}}>
                                <table style={{width: "100%"}} className="polaris-table-preview">
                                    <tbody>
                                    {chart.map((row, i) => (
                                        <tr key={i} className="polaris-table__tr">
                                            {row.map((column, j) => (
                                                <td key={j}
                                                    className={"polaris-table__td esc-size-guide--cell esc-size-guide--row" + (i + 1)}>
                                                    {isHeader(i, j) && column.type === 'text' &&
                                                        <strong>{column.value}</strong>}
                                                    {isHeader(i, j) && column.type === 'html' && (
                                                        <strong
                                                            dangerouslySetInnerHTML={{__html: column.value}}></strong>
                                                    )}
                                                    {!isHeader(i, j) && column.type === 'text' &&
                                                        <span>{column.value}</span>}
                                                    {column.type === 'img' && <img src={column.value} alt="test"/>}
                                                    {column.type !== 'text' && column.type !== 'img' &&
                                                        <span dangerouslySetInnerHTML={{__html: column.value}}></span>}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        }
                    </Card>
                </Layout.Section>
            </Layout>
            <div style={{paddingBottom: '25px'}}></div>
        </Page>
    );
}

export default Help;
